import { useContext } from 'react';
import { Box, Theme, useTheme } from '@mui/material';
import ConfigurationWrapper from '../../components/shared/ConfigurationWrapper';
import PanelPersonalisation from '../../components/configuration/personalisation/PanelPersonalisation';
import { ReactComponent as PersonalisationIcon } from '../../assets/icons/Personalisation.svg';
import { ReactComponent as LocationIcon } from '../../assets/icons/Location.svg';
import { useModuleDurationTracking } from '../../hooks/useModuleDurationTracking';
import { GroupContext } from '../../context/GroupContext';
import { CompanyContext } from '../../context/CompanyContext';

const ConfigurationPersonalisation = () => {
  const { group } = useContext(GroupContext);
  const { company } = useContext(CompanyContext);

  if (!group || !company) return null;

  // Track module duration.
  useModuleDurationTracking('Configuration', 'Personalisation', group.id, company.id);

  const theme: Theme = useTheme();
  const primary_blue: string = theme.palette.primary.main;
  const dark_teal: string = theme.palette.teal.dark;

  return (
    <Box>
      <ConfigurationWrapper
        title="Personalisation"
        icon={<PersonalisationIcon height={50} stroke={primary_blue} fill="none" strokeWidth={3} />}
        previous={null}
        next={{
          route: '/configuration/geographical',
          label: 'Geographical',
          icon: <LocationIcon height={30} fill={dark_teal} stroke={dark_teal} />
        }}
      >
        <PanelPersonalisation />
      </ConfigurationWrapper>
    </Box>
  );
};

export default ConfigurationPersonalisation;
